'use strict';
import {KbCookiebar} from "./kb-cookiebar";
import {KbCookies} from "./kb-cookies";

declare var dataLayer: [];

declare global {
    interface Window {
        cookieBar: KbCookiebar;
    }
}

/**
 * this class handle js links
 */
export class clickManager {

    private selector:string = 'data-kb-click-href';

    constructor() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.onContentLoaded);
        }
        else {
            this.onContentLoaded();
        }
    }

    /**
     * set up listeners on pre-determined elements (those with data-kb-click-href, data-kb-dci & data-kb-aci)
     */
    private onContentLoaded() {
        let elements = document.querySelectorAll('['+ this.selector +']');
        let nbElements = elements.length;

        for (let i = 0; i < nbElements; i++) {
            const el = elements[i];
            let href = el.getAttribute(this.selector) || '';
            el.addEventListener('click', (event: Event) => {
                if (!href) {
                    return;
                }
                clickManager.openLink(href, el, event);
            });
        }

        elements = document.querySelectorAll('[data-kb-dci]');
        nbElements = elements.length;

        for (let i = 0; i < nbElements; i++) {
            const el = elements[i];
            let departureCityId = el.getAttribute('data-kb-dci') || '';
            let arrivalCityId = el.getAttribute('data-kb-aci') || '';

            el.addEventListener('click', function() {
                if (!departureCityId) {
                    return;
                }

                let href = window.linkTemplate.replace("-1", departureCityId).replace("-2", arrivalCityId);

                clickManager.openLink(href, el);
            });
        }
    }

    /**
     * Checks for analytics and open link
     *
     * @param href
     * @param el
     */
    private static openLink(href: any, el: any, event: Event|null = null) {
        const inNewWindow = el.hasAttribute('data-kb-click-new-window') || el.hasAttribute('data-kb-cnw');

        if (event && el.hasAttribute('data-kb-click-skin')) {
          const eventTarget = event.target as HTMLElement;

          if (!(eventTarget.matches('#app, img'))) {
            return;
          }

          if (eventTarget.closest('.skin-contained-column, #tarteaucitronRoot')) {
            return;
          }
        }

        if(href.charAt(0) === '|'){
            // obf
            href = window.linkTemplate.replace(/\|/g, '/')
                .replace(/\!/g, '?')
                .replace(/\%/g, '&')
                .replace('*p', '.php')
                .replace('*h', '.html');
        }

        const listener = function(finalhref: any) {
            if (!inNewWindow) {
                window.location.href = finalhref;
                return;
            }

            window.open(href, '_blank');
        };

        // get cookie managing cookie
        let cookieValue = KbCookies.getCookie(KbCookiebar.cookieName);

        if(cookieValue) {
            // tarteaucitron split services with '!'
            let values =  cookieValue.split('!');

            for (let i = 0; i < values.length; i++) {

                // we seek for kbanalytics service
                if(values[i].search('kbanalytics') != -1){
                    let analytics = values[i].split('=')[1];
                    // 'wait' means no choice was done concerning analytics
                    // OR by clicking this link triggers implicit accept, but analytics is not yet loaded
                    if(analytics != 'wait') {
                        listener(href);
                    } else {
                        const gtmLoaded = dataLayer.find(function (item: any) {
                            return item.event == "gtm.load";
                        });

                        if (gtmLoaded) {
                            document.addEventListener('analytics_loaded', listener);
                        }
                        else {
                            listener(href);
                        }
                    }
                }
            }
        } else {
            listener(href);
        }
    }
}
